export default "__VITE_ASSET__Cb0CXbi6__"